import React, { createElement, ReactNode } from 'react';
import {
    HomeOutlined, UserOutlined, SettingOutlined,
    SmileOutlined, HeartOutlined, CalendarOutlined, OrderedListOutlined,
    UsergroupAddOutlined, DashboardOutlined, CarryOutOutlined, MoneyCollectOutlined,
    FileProtectOutlined, BorderlessTableOutlined, PayCircleOutlined,
    FolderOpenOutlined,
    MailOutlined,
    NodeIndexOutlined,
    TeamOutlined,
    TrophyOutlined,
    WalletOutlined,
    SolutionOutlined,
    ProductOutlined,
    PictureOutlined,
    LaptopOutlined,
    InboxOutlined,
    HistoryOutlined,
    GiftFilled,
    FolderOutlined,
    DeliveredProcedureOutlined,
    ContactsOutlined,
    ContainerOutlined,
    AuditOutlined
} from '@ant-design/icons';

type IconProps = {
    name: string;
    props?: Record<string, any>;
};

const iconMap = {
    HomeOutlined,
    UserOutlined,
    SettingOutlined,
    SmileOutlined,
    HeartOutlined,
    CalendarOutlined,
    OrderedListOutlined,
    DashboardOutlined,
    UsergroupAddOutlined,
    CarryOutOutlined,
    MoneyCollectOutlined,
    FileProtectOutlined,
    BorderlessTableOutlined,
    PayCircleOutlined,
    FolderOpenOutlined,
    MailOutlined,
    NodeIndexOutlined,
    TeamOutlined,
    TrophyOutlined,
    WalletOutlined,
    SolutionOutlined,
    ProductOutlined,
    PictureOutlined,
    LaptopOutlined,
    InboxOutlined,
    HistoryOutlined,
    GiftFilled,
    FolderOutlined,
    DeliveredProcedureOutlined,
    ContactsOutlined,
    ContainerOutlined,
    AuditOutlined,
};

export const useAntIcons = () => {
    const getIcon = ({ name, props = {} }: IconProps): ReactNode => {
        const IconComponent = iconMap[name as keyof typeof iconMap];
        if (!IconComponent) {
            return createElement(iconMap['FolderOpenOutlined' as keyof typeof iconMap], props);
        }
        return createElement(IconComponent, props);
    };

    const iconNames = Object.keys(iconMap);

    return { getIcon, iconNames };
};
